import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { Tag } from 'react-feather';
import i18next from 'i18next';

import CommonSection from 'app/components/common/CommonSection';
import { PaymentOptionIcons } from 'app/components/icons/IconSets';
import { EPaymentType } from 'enums';
import { PageComponent } from 'app/types-global';

const ReferralsPage: PageComponent<{}> = () => {
  return (
    <CommonSection header={i18next.t('referrals-page.header')}>
      <div className="d-flex flex-column flex-md-row justify-content-center align-items-center align-items-md-start mt-3">
        <Card className="mw-300 mb-0">
          <CardBody>
            <div className="text-primary text-center h3">
              <Tag />
            </div>
            {i18next.t('referrals-page.reward-free-month')}
          </CardBody>
        </Card>
        <span className="h4 m-3 my-md-1 align-self-center">{i18next.t('referrals-page.or')}</span>
        <Card className="mw-300 mb-0">
          <CardBody>
            <div className="text-primary text-center h3">
              {PaymentOptionIcons[EPaymentType.CASH]}
            </div>
            {i18next.t('referrals-page.reward-voucher')}
          </CardBody>
        </Card>
      </div>
    </CommonSection>
  );
};

ReferralsPage.navName = 'Zarabiaj polecając';
ReferralsPage.url = '/referrals';

export default ReferralsPage;
